import Noty from 'noty';

class Notification {
    public success = (msg: string, timeout?: number) => {
        this.triggerNotification('success', msg, timeout);
    };

    public info = (msg: string) => {
        this.triggerNotification('info', msg);
    };

    public warn = (msg: string) => {
        this.triggerNotification('warning', msg);
    };

    public error = (msg: string, timeout: number = 0) => {
        this.triggerNotification('error', msg, timeout);
    };

    private triggerNotification = (type: Noty.Type, text: string, timeout: number = 5000) => {
        const message = typeof text === 'string' ? text : String(text);

        try {
            setTimeout(() => {
                new Noty({
                    text: message.replace(/\n/g, '<br/>'),
                    type,
                    theme: 'mint',
                    timeout: timeout > 0 ? timeout : false,
                    layout: 'bottomRight',
                }).show();
            }, 0);
        } catch (e) {
            // ignore
        }
    };
}

export const notification = new Notification();
